<template>
  <ion-card
    color="secondary"
    class="call-to-action"
    data-test="call-to-action"
    tabindex="0"
    @click="gotoLink"
    @keydown.enter="gotoLink"
  >
    <h4>
      <img v-if="icon" :src="icon" alt="" data-test="card-thumbnail" />
      <div class="card-header">
        {{ title }}
      </div>
    </h4>
    <ion-card-content>{{ description }}</ion-card-content>
    <ion-button size="default" disabled="true" :aria-label="buttonText">
      {{ buttonText }}
    </ion-button>
  </ion-card>
</template>

<script>
import { IonCard, IonCardContent } from "@ionic/vue";
export default {
  name: "featurePanel",
  components: {
    IonCard,
    IonCardContent,
  },
  props: {
    icon: { type: String },
    title: { type: String },
    description: { type: String },
    buttonText: { type: String },
    link: { type: String },
  },
  computed: {
    // Computed property to determine the link target based on the link value. always open up external urls in a new tab
    // and internal links in the same tab.
    getLinkTarget() {
      if (this.link.startsWith("http")) {
        return "_blank";
      } else {
        return "_self";
      }
    },
  },
  methods: {
    // Method to handle the click event and navigate to the link
    gotoLink() {
      if (this.link) {
        window.open(this.link, this.getLinkTarget);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/common/theme/breakpoints.scss";
.call-to-action {
  position: relative;
  width: 360px;
  display: inline-block;
  padding: 16px;
  margin-left: 0;
  box-shadow: var(--shadow-1);
  border-radius: 16px;
  cursor: pointer;
  transition: box-shadow var(--transition-time);
  height: 224px;

  &:hover {
    box-shadow: var(--shadow-2);
  }

  &:focus-visible {
    background-color: var(--ion-color-secondary-tint);
    outline: 2px solid var(--ion-color-secondary);
    box-shadow: inset 0px 0px 0px 1px var(--background-white);
  }

  ion-card-content,
  .card-header {
    letter-spacing: 0.25px;
    width: 100%;
  }

  ion-card-content {
    text-align: left;
    padding: 0 16px 0 42px;
  }

  ion-button {
    position: absolute;
    left: 16px;
    bottom: 16px;
    width: 360px-32px;

    &:hover,
    &[hover] {
      // Dont apply the default hover on this button
      --box-shadow: var(--shadow-0);
      --background-hover: var(--ion-colour-primary);
    }
    &[disabled] {
      // Dont apply the default disabled on this button
      opacity: 1;
    }
  }

  h4 {
    margin-top: 0;
    font-size: 30px;
    font-weight: 400;
    display: flex;
    text-align: left;

    img {
      max-width: 32px;
      height: 32px;
      margin-top: 4px;
      margin-right: 9px;
    }

    .card-header {
      display: inline-block;
    }
  }
}

@include breakpoint(small) {
  .call-to-action {
    width: 443px;
    height: 204px;

    ion-button {
      width: 443px-32px;
    }

    h4 {
      font-size: 34px;
      font-weight: 500;
    }
  }
}
</style>
